export enum AlertSearchFilterOrderBy {
  alertId = 'AlertId',
  failure = 'Failure',
  location = 'Location',
  inclusionDate = 'InclusionDate',
  originator = 'Originator',
}
